export { TCSEligibilityStatus } from './generated/TCSEligibilityStatus.js';